
import script from '/home/circleci/app/packages/layout-user-session-component/src/entries/UserSession/index';
script();
